export default __webpack_public_path__ + "static/media/researchBanner.b9826307.jpg";